
interface SvgTextProps {
  text: string;
  color: string;
  x: number;
  y: number;
  fontSize: number;
  fontWeight: string;
  textAnchor: string;
  letterSpacing?: number;
  hasEffect: boolean;
}

export default function SvgText(
  props: SvgTextProps)
{
  const { text, color, x, y, fontSize, fontWeight, textAnchor, hasEffect } = props;

  const blurId = `blurFilter${fontSize}`;
  const letterSpacing = props.letterSpacing ? props.letterSpacing : 0;

  return (
    <g>
      {hasEffect && <defs>
        <filter id={blurId} x="0" y="0">
          <feGaussianBlur in="SourceGraphic" stdDeviation={fontSize * 0.1} />
        </filter>
      </defs>}
      {hasEffect && <text 
        x={x} y={y} 
        fontSize={fontSize} 
        stroke="#fff"
        strokeWidth={0.15 * fontSize * 2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fontFamily="Montserrat"
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
        filter={`url(#${blurId})`}
      >
        {text}
      </text>}
      {hasEffect && <text 
        x={x} y={y} 
        fontSize={fontSize} 
        fill="none"
        stroke="#DAE5D4"
        strokeWidth={0.07 * fontSize}
        fontFamily="Montserrat"
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
      >
        {text}
      </text>}
      <text  
        x={x} y={y} 
        fontSize={fontSize} 
        fill={color}
        fontFamily="Montserrat"
        fontWeight={fontWeight}
        letterSpacing={letterSpacing}
        textAnchor={textAnchor}
      >
         {text}
      </text>
    </g>
  )

}

